export default __webpack_public_path__ + "static/media/filter-4.cd861555.svg";